/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { LiveManagementDeleteLivecarpResponse } from './LiveManagementDeleteLivecarpResponse';

export type LiveManagementDeleteLivecarpResponseApiRespoonse = {
    data?: LiveManagementDeleteLivecarpResponse;
    status?: LiveManagementDeleteLivecarpResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace LiveManagementDeleteLivecarpResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

